/*
 * File: useLogoutAlertTimer.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles setting the autologout timer and will show an alert before
 * the logout happens
 */

import { useState, useEffect, useCallback } from "react";

let timer;
const useLogoutAlertTimer = logoutMinutes => {
  // local state determine when the timer is done to show the alert
  const [done, setDone] = useState(false);

  // starts the timeout
  const start = useCallback(() => {
    // this needs to be here so only one instance of "timer" is set
    clearTimeout(timer);
    timer = setTimeout(() => {
      setDone(true);
    }, calcSeconds(logoutMinutes));
  }, [logoutMinutes]);

  useEffect(() => {
    if (done === false) start();
    return () => clearTimeout(timer);
  }, [done, start]);

  // stops the timeout
  const stop = () => {
    clearTimeout(timer);
    setDone(false);
  };

  // converts minutes to milliseconds for the timeout
  const calcSeconds = logoutMinutes => {
    // show alert one minute
    const minutes = Number(logoutMinutes) - 1;
    return 60000 * minutes;
  };

  return {
    done,
    start,
    stop
  };
};

export default useLogoutAlertTimer;
